import React from "react";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import CustomizableSupplies from "./CustomizableSupplies";
import Outlet from "./Outlet";
import Rewards from "./Rewards";
import Specials from "./Specials";
import { User } from "~/common/Store/models/User";
interface Props {
  user: User;
}
const WaysToSave = withUserAndChat(({
  user
}: Props) => {
  return <div className="container py-6 bg-white">
      <div className="relative w-full grid grid-cols-1 xsl:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="ways-to-save">
        <Outlet />
        <CustomizableSupplies />
        <Specials />
        <Rewards user={user} />
      </div>
    </div>;
});
export default WaysToSave;